module.exports = __webpack_public_path__ + "img/smarttile.a94da838.svg";